import React, { useEffect } from 'react'
import axios from 'axios'
import { useAppDispatch } from 'app/hooks'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'
import { getInsightContentData } from 'features/insightContent/asyncThunks'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import { SummaryMetricsCompactWidgetsType } from 'components/widget/SummaryMetricsCompactWidgets/types'
import { createSearches } from 'components/widget/SummaryMetricsCompactWidgets/share/RunSearchEffect'
import { ERROR_MESSAGE } from 'features/insightContent/insightContentSlice'

const RunSearchEffect = ({
  widgetSetting,
  isAudienceQuery,
  children
}: {
  widgetSetting: SummaryMetricsCompactWidgetsType
  isAudienceQuery?: boolean
  children: React.ReactElement
}) => {
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp()

  useEffect(() => {
    // eslint-disable-next-line prefer-destructuring
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()

    const searches = createSearches(widgetSetting, undefined, isAudienceQuery)

    dispatch(
      getInsightContentData({
        insightContentType: InsightContentType.FLUCTUATION_SUMMARY_METRICS,
        searches,
        timestamp: refreshTimestamp,
        requestConfig: {
          cancelToken: source.token
        }
      })
    )

    return () => {
      source.cancel(ERROR_MESSAGE.REQUEST_CANCELLED)
    }
  }, [widgetSetting, dispatch, isAudienceQuery, refreshTimestamp])

  return children
}

export default RunSearchEffect
